// store/modules/athlete_summary.js

export default {
    namespaced: true,
    state: () => ({
        athleteSummary: [],
    }),
    mutations: {
        setAthleteSummary(state, data) {
            state.athleteSummary = data;
        },
        setAthleteSummaryFromList(state, payload) {
            const { competitionId, summary } = payload;
            state.athleteSummary = {
                ...state.athleteSummary,
                [competitionId]: summary
            };
        },
        resetAthleteSummary(state) {
            state.athleteSummary = [];
        },

    },
    actions: {
        setAthleteSummaryBar({ commit }, data) {
            commit('setAthleteSummary', data);
        },
        setAthleteSummaryBarFromList({ commit }, payload) {
            commit('setAthleteSummaryFromList', payload);
        },
        clearAthleteSummaryBar({ commit }) {
            commit('resetAthleteSummary');
        },
    },
    getters: {
        getAthleteSummary: state => state.athleteSummary,
        getAthleteSummaryByCompetition: state => id => state.athleteSummary[id] || {}
    }
};
